import React, { useState } from 'react';
import Text from '@text';
import { Button } from 'audamatic-ui';
import Restapi from '@utils/api';
import PropTypes from 'prop-types';

import './styles.scss';

const GiftcardModalNotification = (props) => {
  const { store } = props;
  const basket = store.getBasket();
  const [errorMsg, setErrorMsg] = useState('');
  const api = new Restapi();

  const deleteAllGiftcards = () => {
    api.deleteGiftcards(basket.id)
      .then(() => {
        store.modal.closeModal();
      })
      .catch(() => {
        setErrorMsg(true);
      });
  };

  return (
    <div className="giftcard-modal-notification" data-test-id="modal-giftcardNotification">
      <p><Text>giftcard.modal.notification</Text></p>
      <div className="button-row">
        <Button variant="secondary" size="large" onClick={store.modal.closeModal}>
          <Text>giftcard.modal.cancel</Text>
        </Button>
        <Button variant="primary" size="large" onClick={deleteAllGiftcards}>
          <Text>giftcard.modal.notification-button</Text>
        </Button>
      </div>
      {!!errorMsg && (
        <p className="error-message"><Text>giftcard.modal.notification-error</Text></p>
      )}
    </div>
  );
};

GiftcardModalNotification.propTypes = {
  store: PropTypes.object,
};

export default GiftcardModalNotification;
